import { Ic, icons } from "../../components/Icons";

const EyebrowIcon = ({ type = "spark" }) => {
  const paths = {
    software: (
      <>
        <rect x="3.5" y="5" width="17" height="14" rx="3.2" />
        <path d="M7.5 9.2h9" />
        <path d="M8 13.4h3.5" />
        <path d="M14.5 13.4h1.8" />
      </>
    ),
    products: (
      <>
        <path d="M12 3.2 20 7.7v8.6l-8 4.5-8-4.5V7.7L12 3.2Z" />
        <path d="m4.5 8 7.5 4.2L19.5 8" />
        <path d="M12 12.2v8.1" />
      </>
    ),
    stores: (
      <>
        <rect x="4.2" y="5.8" width="15.6" height="13.2" rx="3" />
        <path d="M8.2 5.8c.45-1.75 1.7-2.8 3.8-2.8s3.35 1.05 3.8 2.8" />
        <path d="M9 11.2h6" />
        <path d="M9 14.8h4.2" />
      </>
    ),
    workflow: (
      <>
        <circle cx="6" cy="7" r="2.2" />
        <circle cx="18" cy="17" r="2.2" />
        <path d="M8.2 7h4.3c2.7 0 4.5 1.8 4.5 4.4V14" />
        <path d="m14.8 12.4 2.2 2.2 2.2-2.2" />
      </>
    ),
    features: (
      <>
        <path d="M12 3.5 14.1 9l5.9.4-4.6 3.7 1.4 5.7L12 15.7l-4.8 3.1 1.4-5.7L4 9.4 9.9 9 12 3.5Z" />
      </>
    ),
    demo: (
      <>
        <rect x="4" y="4" width="16" height="16" rx="3" />
        <path d="M8 15.5 12 8l4 7.5" />
        <path d="M9.4 13.2h5.2" />
      </>
    ),
    people: (
      <>
        <circle cx="8.2" cy="8.5" r="2.5" />
        <circle cx="15.8" cy="8.5" r="2.5" />
        <path d="M4.8 18c.6-2.5 2.2-3.8 4.8-3.8 1 0 1.8.2 2.4.6" />
        <path d="M11.8 18c.6-2.5 2.2-3.8 4.8-3.8 1.3 0 2.4.4 3.2 1.1" />
      </>
    ),
    spark: (
      <>
        <path d="M12 3.5v4" />
        <path d="M12 16.5v4" />
        <path d="M3.5 12h4" />
        <path d="M16.5 12h4" />
        <path d="m6 6 2.8 2.8" />
        <path d="m15.2 15.2 2.8 2.8" />
        <path d="m18 6-2.8 2.8" />
        <path d="m8.8 15.2-2.8 2.8" />
      </>
    ),
  };

  return (
    <svg className="software-eyebrow-icon" viewBox="0 0 24 24" aria-hidden="true">
      {paths[type] || paths.spark}
    </svg>
  );
};

export default function SectionEyebrow({ icon, children }) {
  return (
    <div className="reveal eyebrow software-eyebrow">
      {icon === "appFeatures" ? (
        <Ic d={icons.appFeatures} size={15} sw={1.7} />
      ) : (
        <EyebrowIcon type={icon} />
      )}
      <span>{children}</span>
    </div>
  );
}
